import { Box, Typography, useMediaQuery } from "@mui/material";
import { commingSoonMsg } from "configs/Constants";
import {
  backgroundColor01,
  bgColor17,
  blackColor,
  blackColor26,
  blackColor27,
  borderCard,
  cartBorderColor01,
  headingColor,
  whiteColor,
} from "configs/styles/muiThemes";
import React from "react";

function CommingSoonCard() {
  let businessFullName = sessionStorage.getItem("businessFullName");
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const images = [
    "/./assets/images/home_empty_box.svg",
    "/./assets/images/home_empty_discount.svg",
    "/./assets/images/home_empty_gift.svg",
    "/./assets/images/home_empty_cart.svg",
    "/./assets/images/home_empty_star.svg",
    "/./assets/images/home_empty_address.svg",
  ];

  return (
    <Box
      mx={{ md: 8, xs: 1.5 }}
      mt={{ md: 5, xs: 2.5 }}
      mb={{ md: 2.5, xs: "80px" }}
      px={{ md: 5, xs: 0 }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        backgroundColor={{ xs: whiteColor, md: whiteColor }}
        borderRadius={"10px"}
        border={"1px solid " + cartBorderColor01}
        p="20px"
      >
        <Box display="flex" gap={{ md: "50px", xs: "10px" }}>
          {images.map((image, index) => {
            if (!matches && index > 0) return;
            return (
              <Box
                key={index}
                sx={{
                  width: { md: "75px", xs: "63px" },
                  height: { md: "75px", xs: "63px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: matches ? borderCard : "1px solid " + bgColor17,
                  background: matches ? whiteColor : bgColor17,
                  borderRadius: "50%",
                }}
              >
                <Box
                  component="img"
                  src={image}
                  width={{ md: "50px", xs: "55px" }}
                  height={{ md: "50px", xs: "55px" }}
                  alt={businessFullName + " CostBo"}
                />
              </Box>
            );
          })}
        </Box>
        <Typography
          mt={{ md: "15px", xs: "12px" }}
          variant="subtitle2"
          fontSize={{ md: 13.5, xs: 11 }}
          color={blackColor26}
          sx={{ width: { xs: "90%", md: "40%" } }}
          fontWeight={400}
          lineHeight={{ xs: "16px", md: "22px" }}
          textAlign="center"
        >
          We are currently adding exciting range of products and discount to
          serve you better.
        </Typography>
        <Typography
          variant="subtitle2"
          fontSize={{ md: 14, xs: 12 }}
          color={blackColor27}
          mt={{ md: "6px", xs: "4px" }}
          pb={{ md: 1, xs: 0 }}
          sx={{ width: { xs: "90%", md: "40%" } }}
          textAlign="center"
          lineHeight="20px"
          fontWeight={600}
        >
          Please check back later.
        </Typography>
      </Box>
    </Box>
  );
}

export default CommingSoonCard;
